import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageContainer from "../../../components/PageContainer";
import { PageHeader } from "../../../components/Layout/PageHeader";
import { translate, Translate } from "react-i18nify";
import { Box, Button, Typography, Stack, Link } from "@mui/material";
import AlertBox from "../../../components/AlertBox";
import { DeviceService } from "../../../services/DataService";
import { BatchTable } from "../../../components/Production/BatchTable";
import { DEVICE_TYPE } from "../Production";
import { Roles } from "../../../redux/actions/auth";
import { DataGrid } from '@mui/x-data-grid';
import { TestResultBox } from "../../../components/Test/TestResultBox";

import { ConfirmDialog, DIALOGTYPE } from "../../../components/Layout/Dialog/ConfirmDialog";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { EMS_DMR_HIGHLIGHT } from "../../ProDevices/ProDevice";


export const O2maticQa=(props)=>{
    const { udsn, type } = useParams();

    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const [submitState, setSubmitState] = useState(true);
  
    const [selectedDevices, setSelectedDevices] = useState({});
    const [selectedDeviceReadyForApproval, setSelectedDeviceReadyForApproval] = useState({});
  
    const [devices, setDevices] = useState({});
    const [devicesReadyForApproval, setDevicesReadyForApproval] = useState({});

    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [udsnToApprove, setUdsnToApprove] = useState(null);
    const [confirmStatus, setConfirmStatus] = useState({status: 0, body: null});
  
    const [alertBox, setAlertBox] = useState({
      visibility: false,
      statusCode: null,
      text: null,
      error: null,
    });
  
    const handleAlertBox = (visibility, statusCode, text, error) => {
      setAlertBox({
        visibility: visibility,
        statusCode: statusCode,
        text: text,
        error: error,
      });
    };
  
    const dismissAlertBox = () => {
      setAlertBox({
        visibility: false,
        statusCode: null,
        text: null,
        error: null,
      });
    };
  
    // get device data for devices that have just been Production QA Approved
    useEffect(() => {
      (async () => {
        let templateId=-1;
        switch(type){
          case DEVICE_TYPE.PRO100.code:{
            templateId=1
            break;
          }
          case DEVICE_TYPE.HOT.code:{
            templateId=12
            break;
          }
  
        }
        let result = await DeviceService.getBatchByTemplate("Prod QA Approved", templateId,[Roles.O2maticQa], true);
        setDevices(result.data);
      })();
    }, []);

    // get device data for devices that are "Ready for approval" (O2matic tested devices)
    useEffect(() => {
      (async () => {
        let templateId=-1;
        switch(type){
          case DEVICE_TYPE.PRO100.code:{
            templateId=1
            break;
          }
          case DEVICE_TYPE.HOT.code:{
            templateId=12
            break;
          }
  
        }

        let results = await DeviceService.getByTemplateWRoles(templateId, 0, 500,"ReadyForO2maticApproval",[Roles.O2maticQa], true);
        setDevicesReadyForApproval(results.data);
        setLoading(false);
      })();
    }, []);

    useEffect(() => {
      if(Object.keys(selectedDevices).length > 0){
        const isSelected = getSelected(selectedDevices)
        setSubmitState(isSelected.length <= 0) // if a device is selected (isSelected = true), the button needs to be pressable (disabled = false). That is why the '!' prosseds isSelected 
      }
    },[selectedDevices])

    const getSelected = (batches) => {
      let data = []
      Object.keys(batches)?.forEach((batch) => {
        selectedDevices[batch].devices?.forEach((device) => {
          if(device.selected){
            data.push(device.device.id)
          }
        });
      });
      return data
    }

    //Action => true = approved, false = rejected
    //see QAACTION constant in the button of this file
    const handleSubmit = async (action) => {
      let data = getSelected(selectedDevices);
      if(data.length==0){
        return;
      }
      setSubmitState(true);
        try {
          let result = await DeviceService.o2maticQaApproveDevice(data, action);
  
          if (result.status >= 200 && result.status < 300) {
            handleAlertBox(true, result.status, "Device(s) O2matic QA Approved", null);
          } else {
            handleAlertBox(true, result.status, result.statusText, null);
          }
          setTimeout(() => {
            navigate(`/production/${type}`);
          }, 2000);
        } catch (e) {
          handleAlertBox(true, e.status, e.statusText, e.message);
          setSubmitState(false);
        }
  
    };

    // Content for: O2matic tested devices
    const columns = [
      {
          field: 'udsn', headerName: 'UDSN', flex: 1, 
          valueGetter: (device) => { 
              return device.row.metaData.find(x => x.metadataId == 1)?.value;
          },
          renderCell: (device) => {
            const udsn = device.row.metaData.find(x => x.metadataId == 1)?.value
            return <Link href={`device/${type === DEVICE_TYPE.HOT ? "HOT" : "PRO"}/${udsn}`} color="inherit" underline="hover">{udsn}</Link>
          }
      },
      {
          field: 'status', headerName: 'Status', flex: 1, 
          valueGetter: (status) => {
              return status.row.metaData.find(x => x.metadataId == 2)?.value;
          }
      },
      {
          field: 'test', headerName: 'Last Test', flex: 1, 
          valueGetter: (devices) => {
            if(devices.row.testResults?.length > 0){
              return devices.row.testResults[0].passed
            }
            else
              return null
          },
          renderCell: (devices) => {
            const testResult = devices.row.testResults?.length > 0 ? devices.row.testResults[0] : null
              return (
                  <TestResultBox testResult={testResult} width={"40%"} />
              )
          }
      },
    ];

    const handleApprovePopup = (params, event) => {
      let row = params.row;
      var udsn = row.metaData.find(x => x.metadataId == 1).value;
      setUdsnToApprove(udsn);

      // get device id based on udsn
      const deviceId = devicesReadyForApproval.find(
        d => d.metaData.find(md => md.metadataId === 1).value === udsn
      ).id;
      if(deviceId != null){
          setSelectedDeviceReadyForApproval(deviceId)
          setShowConfirmDialog(true);        
      }
    };

    const handleQAAction = (action) => {
      let data = [];
      data.push(selectedDeviceReadyForApproval);
      try {
        DeviceService.o2maticQaApproveDeviceFromO2maticTested(data, action).then(result => {
          handleAlertBox(true, result.status,  `Device O2matic QA ${action ? "approved" : "rejected"}`, null);
        }).catch(result =>{
          handleAlertBox(true, result.status, result.statusText, null);
        });
        setTimeout(() => {
          navigate(`/production/${type}`);
        }, 2000);
      } catch (e) {
        handleAlertBox(true, e.status, e.statusText, e.message);
      }

    };

    const closeConfirmDialog = async () => {
        setShowConfirmDialog(false);
        setUdsnToApprove(null);
    }



    return (
      <>
      <PageContainer>
        <PageHeader leftAlign>
          <Translate value="O2maticQAAprove" />
        </PageHeader>


        <Typography sx={{ mt: 1, mb: 1 }} variant="h5">
          <Translate value="ProductionQAApprovedReady"/>
        </Typography>

        <Typography sx={{ mt: 1, mb: 1 }} variant="body">
          <Translate value="O2maticQAAproveMessage" />
        </Typography>
        <BatchTable
          data={devices}
          onSelectedUpdate={(devices) => setSelectedDevices(devices)}
        />
        
        <Box>
          
            <Button
            id={"RejectBatchBtn"}
            disabled={submitState}
            onClick={() => handleSubmit(QAACTION.REJECT)}
            sx={{ mt: 2, mr: 3, width: "100px" }}
            color="error"
            variant="contained"
            >
            <Translate value="Reject"/>
          </Button>
          <Button
            id={"ApproveBatchBtn"}
            disabled={submitState}
            onClick={() => handleSubmit(QAACTION.APPROVE)}
            sx={{ mt: 2,   width: "100px"}}
            color="success"
            variant="contained"
            >
            <Translate value="Approve"/>
          </Button>
        </Box>

        <Typography sx={{ mt: 5, mb: 1 }} variant="h5">
          <Translate value="O2maticTestedReady"/>
        </Typography>
        <Typography sx={{ mt: 1, mb: 1 }} variant="body">
          <Translate value="O2maticTestedQAAproveMessage" />
        </Typography>

        <Box sx={{ width: "100%" }}>
          <DataGrid
              ColumnWidth="*"
              sx={{ 
                height: 300, 
                mt: 2,
                "& .dmr-color-EMS": {
                    backgroundColor: EMS_DMR_HIGHLIGHT.color
                },
                "& .dmr-color-EMS:hover": {
                    backgroundColor: EMS_DMR_HIGHLIGHT.hoverColor
                },
              }}
              columns={columns}
              rows={devicesReadyForApproval}
              pageSize={50}
              rowsPerPageOptions={[50]}
              onCellClick={(params, event) => {
                if(params.field !== "test" && event.target?.href == null){
                  handleApprovePopup(params, event)
                }
              }}
              loading={loading}
              components={{
                NoRowsOverlay: () => (
                  <Stack height="100%" alignItems="center" justifyContent="center">
                    <Translate value="NoRowsDevices" />
                  </Stack>
                ),
                NoResultsOverlay: () => (
                    <Stack height="100%" alignItems="center" justifyContent="center">
                      <Translate value="NoResults" />
                    </Stack>
                )
            }}
            getRowClassName={(params) => `dmr-color-${params.row.metaData.find(x => x.metadataId === 4)?.value === EMS_DMR_HIGHLIGHT.value ? "EMS" : "regular"}` }
          />
        </Box>

        <AlertBox
          visible={alertBox.visibility}
          text={alertBox.text}
          error={alertBox.error}
          statusCode={alertBox.statusCode}
          onHide={dismissAlertBox}
        />

      </PageContainer>
      <ConfirmDialog
        type={DIALOGTYPE.O2MATICQA}
        dialogIcon={<Translate value="O2maticQAAprove" />}
        title={udsnToApprove}
        // message={ {qaMessage: "O2maticQaApproveText"} }
        confirmText={<Translate value="Approve" />}
        declineText={ <Translate value="Reject" />}
        confirmButtonVariant="success"
        rejectButtonVariant="error"
        open={showConfirmDialog}
        onConfirm={() => handleQAAction(QAACTION.APPROVE)}
        onClose={() => handleQAAction(QAACTION.REJECT)}
        confirmStatus={confirmStatus}
    >
      <Typography sx={{ width: "100%", textAlign: "center" }} component="div" variant="body1">
          {translate("O2maticQaApproveText")}
      </Typography>
    </ConfirmDialog>
    </>
    );
}

const QAACTION = {
  APPROVE: true,
  REJECT: false
}